import {
  Paper,
  Typography,
  Box,
  TextField,
  InputAdornment,
  Button,
  Chip,
  Tooltip,
  Divider,
} from "@mui/material";
import { Info as InfoIcon } from "@mui/icons-material";
import { useEffect, useState } from "react";

export default function RetencionesCard({
  retSuss,
  retIva,
  retGanancias,
  retDrei,
  retencionesIIBB,
  totalIIBB,
  onRetencionChange,
  onOpenIIBBModal,
  handleImporteChange,
  formatCurrency,
  getProvinciaNombre,
}) {
  const [localDrei, setLocalDrei] = useState(retDrei || "");
  const [localSuss, setLocalSuss] = useState(retSuss || "");
  const [localIva, setLocalIva] = useState(retIva || "");
  const [localGanancias, setLocalGanancias] = useState(retGanancias || "");

  useEffect(() => {
    setLocalDrei(retDrei || "");
  }, [retDrei]);
  useEffect(() => {
    setLocalSuss(retSuss || "");
  }, [retSuss]);
  useEffect(() => {
    setLocalIva(retIva || "");
  }, [retIva]);
  useEffect(() => {
    setLocalGanancias(retGanancias || "");
  }, [retGanancias]);

  return (
    <Paper elevation={2} sx={{ p: 2 }}>
      <Typography
        variant="subtitle2"
        fontWeight="bold"
        gutterBottom
        color="primary"
      >
        Retenciones
      </Typography>

      <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1.5 }}>
        <TextField
          onWheel={(e) => e.target.blur()}
          sx={{
            "& input[type=number]": {
              MozAppearance: "textfield", // Firefox
            },
            "& input[type=number]::-webkit-outer-spin-button": {
              WebkitAppearance: "none",
              margin: 0,
            },
            "& input[type=number]::-webkit-inner-spin-button": {
              WebkitAppearance: "none",
              margin: 0,
            },
          }}
          label="Ret SUSS"
          type="number"
          value={localSuss}
          onChange={(e) => setLocalSuss(e.target.value)}
          onBlur={(e) =>
            handleImporteChange(e, (v) => onRetencionChange("retSuss", v))
          }
          size="small"
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          }}
        />
        <TextField
          label="Ret IVA"
          onWheel={(e) => e.target.blur()}
          sx={{
            "& input[type=number]": {
              MozAppearance: "textfield", // Firefox
            },
            "& input[type=number]::-webkit-outer-spin-button": {
              WebkitAppearance: "none",
              margin: 0,
            },
            "& input[type=number]::-webkit-inner-spin-button": {
              WebkitAppearance: "none",
              margin: 0,
            },
          }}
          type="number"
          value={localIva}
          onChange={(e) => setLocalIva(e.target.value)}
          onBlur={(e) =>
            handleImporteChange(e, (v) => onRetencionChange("retIva", v))
          }
          size="small"
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          }}
        />
        <TextField
          label="Ret DREI"
          onWheel={(e) => e.target.blur()}
          sx={{
            "& input[type=number]": {
              MozAppearance: "textfield", // Firefox
            },
            "& input[type=number]::-webkit-outer-spin-button": {
              WebkitAppearance: "none",
              margin: 0,
            },
            "& input[type=number]::-webkit-inner-spin-button": {
              WebkitAppearance: "none",
              margin: 0,
            },
          }}
          type="number"
          value={localDrei}
          onChange={(e) => setLocalDrei(e.target.value)}
          onBlur={(e) =>
            handleImporteChange(e, (v) => onRetencionChange("retDrei", v))
          }
          size="small"
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          }}
        />
        <TextField
          label="Ret Ganancias"
          onWheel={(e) => e.target.blur()}
          sx={{
            "& input[type=number]": {
              MozAppearance: "textfield", // Firefox
            },
            "& input[type=number]::-webkit-outer-spin-button": {
              WebkitAppearance: "none",
              margin: 0,
            },
            "& input[type=number]::-webkit-inner-spin-button": {
              WebkitAppearance: "none",
              margin: 0,
            },
          }}
          type="number"
          value={localGanancias}
          onChange={(e) => setLocalGanancias(e.target.value)}
          onBlur={(e) =>
            handleImporteChange(e, (v) => onRetencionChange("retGanancias", v))
          }
          size="small"
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          }}
        />

        <Box sx={{ gridColumn: "span 2" }}>
          <Typography
            variant="caption"
            display="flex"
            alignItems="center"
            gap={0.5}
            mb={0.5}
          >
            Ret IIBB
            {retencionesIIBB.length > 0 && (
              <Tooltip
                title={
                  <Box>
                    {retencionesIIBB.map((r, i) => (
                      <Box
                        key={i}
                        display="flex"
                        justifyContent="space-between"
                        gap={2}
                      >
                        <span>{getProvinciaNombre(r.provincia_id)}:</span>
                        <span>
                          {formatCurrency(parseFloat(r.importe) || 0)}
                        </span>
                      </Box>
                    ))}
                    <Divider sx={{ my: 0.5, bgcolor: "white" }} />
                    <Box
                      sx={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Typography variant="caption" fontWeight="bold">
                        Total: {formatCurrency(totalIIBB)}
                      </Typography>
                    </Box>
                  </Box>
                }
              >
                <InfoIcon fontSize="small" color="action" />
              </Tooltip>
            )}
          </Typography>
          <Button
            variant="outlined"
            size="small"
            onClick={onOpenIIBBModal}
            fullWidth
          >
            {totalIIBB > 0 ? formatCurrency(totalIIBB) : "Desglosar"}
            {retencionesIIBB.length > 0 && (
              <Chip
                label={retencionesIIBB.length}
                size="small"
                sx={{ ml: 1 }}
              />
            )}
          </Button>
        </Box>
      </Box>
    </Paper>
  );
}
